
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { OccupationalHealth } from '../../../models/tables/tiss/occupational-health';

@Injectable()
export class OccupationalHealthListProvider implements Resolve<any> {
    occupationalHealth: OccupationalHealth[];
    occupationalHealthEdit: OccupationalHealth;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.occupationalHealthEdit = this.state?.currentOccupationalHealth;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'code';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<OccupationalHealth> {
        if (!id) {
            return null;
        }
        return this.gw.get('occupationalHealth/:id', { id: id });
    }

    get currentOccupationalHealth(): OccupationalHealth {
        return this.occupationalHealthEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('occupationalHealth/simple/').subscribe((res: HttpResponse<any>) => {
                this.occupationalHealth = res.body;
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('occupationalHealth/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.occupationalHealth, res.body.content) && res.body.content.length > 0) {
                    this.occupationalHealth = res.body.content;
                    this.onDataChanged.next(this.occupationalHealth);
                }
                else {
                    this.occupationalHealth = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

